<template>
  <router-view />
</template>

<script>
export default {
  name: 'AlertsWrapper',
  created() {},
  destroyed() {},
};
</script>
